const theme = {
  fontFamily:
    "ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji",
  backgroundImage:
    "url('https://virtualsports.sportradar.com/static/media/Blue_bg_1.4e9bdd44dc09af587cbe.png')",
  colors: {},
  skeleton: {
    backgroundColor: "transparent",
    filter: "brightness(140%)",
  },
  sliderTitle: {
    color: "#e5e5e5",
    fontSize: "24px",
    fontWeight: "600",
  },
  image: {
    aspectRatio: "4 / 3",
    borderRadius: "6px",
  },
  sliderItemLabel: {
    color: "#fff",
    fontWeight: 600,
  },
  moreBtn: {
    display: "none",
  },
  sliderHeader: {
    margin: "20px 65px",
  },
  sliderHeaderSmall: {
    margin: "20px 35px",
  },
  sliderHeaderMobile: {
    margin: " 20px 10px",
  },
  playBtnHighlights: {
    color: "#ff0000",
  },
  slideBtn: {
    backgroundColor: "rgba(0,0,60,0.4)",
    color: "#fff",
  },
};

export default theme;
